import React, { useEffect } from 'react';

import LinearGradient from 'react-native-linear-gradient';
import Animated, {
    useAnimatedStyle,
    useSharedValue,
    withTiming,
} from 'react-native-reanimated';

import { blackTransparent } from 'utils/colors';

import Text, { ETextCategory, ETextColor } from 'components/Text';

import styles from './styles';

type Props = {
    title?: string;
    showGradient?: boolean;
};

const bottomGradientColors = [
    blackTransparent(0),
    blackTransparent(0.008),
    blackTransparent(0.03),
    blackTransparent(0.08),
    blackTransparent(0.14),
    blackTransparent(0.23),
    blackTransparent(0.33),
    blackTransparent(0.44),
    blackTransparent(0.55),
    blackTransparent(0.66),
    blackTransparent(0.76),
    blackTransparent(0.85),
    blackTransparent(0.91),
    blackTransparent(0.96),
    blackTransparent(0.99),
    '#000000',
];

function EpgProgramListHeader({ title, showGradient }: Props) {
    const opacitySharedValue = useSharedValue(Number(showGradient));
    const animatedStyle = useAnimatedStyle(() => ({
        opacity: opacitySharedValue.value,
        zIndex: 100,
    }));

    useEffect(() => {
        opacitySharedValue.value = withTiming(Number(showGradient), {
            duration: 300,
        });
    }, [showGradient]);

    return title ? (
        <>
            {showGradient && (
                <Animated.View
                    style={[styles.gradientContainer, animatedStyle]}
                >
                    <LinearGradient
                        style={styles.gradient}
                        colors={[...bottomGradientColors].reverse()}
                    />
                </Animated.View>
            )}
            <Text
                numberOfLines={1}
                category={ETextCategory.title2}
                color={ETextColor.neutral}
                style={styles.title}
                accessible
            >
                {title}
            </Text>
        </>
    ) : null;
}

export default EpgProgramListHeader;
